@if(data) {
  <div>
    <h2 class="text-lg font-semibold text-gray-900 mb-2">Primary Endpoints</h2>
    <ul class="list-disc list-inside mb-4">
      @for(endpoint of primaryEndpoints; track endpoint) {
      <li class="text-gray-800 mb-1">{{ endpoint }}</li>
      }
    </ul>

    <h2 class="text-lg font-semibold text-gray-900 mb-2">Secondary Endpoints</h2>
    <ul class="list-disc list-inside">
      @for(endpoint of secondaryEndpoints; track endpoint) {
      <li class="text-gray-800 mb-1">{{ endpoint }}</li>
      }
    </ul>
  </div>
}